const sliderSetting = require('./caroucel-setting');
const toggleSetting = require('./toggle-setting');
const menu = require('./menu');
const modal = require('./modal');
const pageNavigation = require('./page-navigation');
const tabSetting = require('./tab-setting');
const toc = require('./toc');
const stickyHeader = require('./sticky-header');
const smoothScroll = require('./smooth-scroll');